<div #outsideModal class="modal">
  <div #modalBody class="modal-content" style="position:relative;">
    <div class="modal-header">Déploiement du Cabinet</div>
    <frg-cards *ngIf="!instancesValues || instancesValues.length == 0" class="not-accessible-container" [border]="false" title="Deploiement impossible">
      <div style="margin-left: 2.5rem; font-weight: 500; font-size: 1.5rem;">
          Aucune instance disponible
          <div class="button-wrapper">
            <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal()" style="margin-left: 0;">Fermer</frg-button>
          </div>
      </div>
      <svg id="svg-filter">
        <filter id="svg-blur">
            <feGaussianBlur in="SourceGraphic" stdDeviation="4"></feGaussianBlur>
        </filter>
      </svg>
    </frg-cards>
    <div class="modal-body" *ngIf="formGroup" [ngClass]="{'disabled-content': !instancesValues || instancesValues.length == 0}">
      Choix des instances de base de données
      <frg-form-input label="Instance pour Base de données Médicale" id="dbmedical" type="text" [selectValue]="instancesValues"
          errorMessage="Veuillez choisir une instance pour la base de données Médicale" [formGroup]="formGroup" [control]="formGroup.get('dbMedical')"
          required="true">
      </frg-form-input>
      <frg-form-input label="Instance pour Base de données Utilisateur" id="dbuser" type="text" [selectValue]="instancesValues"
          errorMessage="Veuillez choisir une instance pour la base de données Utilisateur" [formGroup]="formGroup" [control]="formGroup.get('dbUser')"
          required="true">
      </frg-form-input>
      <frg-form-input label="Instance pour Base de données Log" id="dblog" type="text" [selectValue]="instancesValues"
          errorMessage="Veuillez choisir une instance pour la base de données Log" [formGroup]="formGroup" [control]="formGroup.get('dbLog')"
          required="true">
      </frg-form-input>
      <div class="button-wrapper">
        <frg-button backgroundColor="var(--darkest-primary)" (activated)="closeModal()">Annuler</frg-button>
        <frg-button (activated)="validForm()" [disabled]="!formGroup.valid">Valider</frg-button>
      </div>
    </div>
  </div>
<div class="modal-background"></div>

